import React from 'react';
import { User } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const CppTeacherInfo = () => {
  const { language } = useLanguage();

  return (
    <section className="cpp-section">
      <div className="cpp-container">
        {/* Teacher Information Only */}
        <div className="cpp-card text-center">
          <h2 className="cpp-heading-2 text-white mb-8">
            {language === 'ar' ? 'المدرب' : 'Course Instructor'}
          </h2>
          
          <div className="w-20 h-20 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <User className="w-10 h-10 text-white" />
          </div>
          
          <h3 className="cpp-heading-1 text-purple-400 mb-6">
            {language === 'ar' ? 'المهندس أسامة محمود أبو سمك' : 'Engineer Osama Mahmoud Abu Samak'}
          </h3>
          
          <p className="text-gray-300 max-w-2xl mx-auto leading-relaxed text-lg">
            {language === 'ar' 
              ? 'مهندس مكاترونكس مع خبرة واسعة في تدريس البرمجة والتطوير. ملتزم بتقديم تعليم عالي الجودة وبناء أسس قوية في البرمجة للطلاب.'
              : 'Specialized Mechatronics engineer with extensive experience in programming education and development. Committed to providing high-quality education and building strong programming foundations for students.'
            }
          </p>
        </div>
      </div>
    </section>
  );
};

export default CppTeacherInfo;